import React from "react";
import {

  EditButton,
  TopToolbar,

} from "react-admin";
// import { ROLES } from "../constants";



function ShowActionsPermissionOnlyEdit({ basePath, data, resource }) {
  // const { permissions } = usePermissions();

  return (
    <TopToolbar>
      <><EditButton basePath={basePath} record={data} />
      </>
    </TopToolbar>
  );
}

export default ShowActionsPermissionOnlyEdit;
